import IconButton from '@components/v2/ui/IconButton/IconButton';
import { ArrowLeftRight } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { BrandSelectorTestIds } from '../../../../utils/testIds/brandSelector.testIds';
import BrandSelectorMenu from './BrandSelectorMenu';
import { useBrandSelector } from './hooks/useBrandSelector';

const BrandSelectorTrigger = () => {
  const { translate } = useTranslation();
  const { buttonProps, menuProps } = useBrandSelector();
  return (
    <>
      <IconButton
        icon={ArrowLeftRight}
        size="medium"
        color="secondary"
        testId={BrandSelectorTestIds.TRIGGER_BUTTON}
        ariaLabel={translate(LangEnum.TEAM_MODAL_CHOOSE_BRAND_TITLE)}
        ariaExpanded={Boolean(menuProps.anchorEl)}
        onClick={buttonProps.onClick}
      />
      <BrandSelectorMenu {...menuProps} />
    </>
  );
};

export default BrandSelectorTrigger;
